import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  moleculeAddAction,
  moleculeDeleteAction,
  productPlanningCreateAction,
  productViewAction,
} from "../../redux/actions/product-action";
import AddButton from "../buttons/button";
import InputField from "../forms/input-field";
import successToast from "../helper-components/success-toast";
import { compositionSearchListAction } from "../../redux/actions/settings-action";
import errorToast from "../helper-components/error-toast";
import SelectField from "../forms/select-field";
import DeleteIcon from "../../assets/icons/delete-icon";
import { useParams } from "react-router-dom";

const MoleculeTab = ({
  page,
  productId,
  setFormValues,
  formValues,
  setCurrentTab,
  product,
  disabled = false,
  itemGeneralData = {},

  // compositionList,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const initialValues = {
    // item_id: product?.item_id ?? productId,
    molecule_name: "",
    molecule_value: 0,
    molecule_unit: "",
  };
  const [molecule_name, setMolecule_name] = useState("");
  const [molecule_value, setMolecule_value] = useState(0);
  const [molecule_unit, setMolecule_unit] = useState("");

  const [compositionList, setCompositionList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [resetFormRef, setResetFormRef] = useState(null);

  const validationSchema = Yup.object({
    molecule_name: Yup.string()
      .required("Molecule name is required")
      .min(2, "Name must be at least 2 characters"),
    molecule_value: Yup.number()
      .required("Weight value is required")
      .positive("Value must be positive"),
    molecule_unit: Yup.string()
      .required("Weight unit is required")
      .min(1, "Unit is required"),
  });
  useEffect(() => {
    if (page === "add") {
      reFetch();
    } else if (itemGeneralData?.molecule_composition?.length > 0) {
      setDataList(itemGeneralData.molecule_composition);
    }
  }, [itemGeneralData, productId]);
  const innerOnSubmit = () => {
    setCurrentTab("Restrictions");
  };

  const onSuccess = (data) => {
    console.log("success data", data?.data[0]?.molecule_composition);
    setDataList(data?.data[0]?.molecule_composition);
    // successToast(data?.message);
  };
  const onError = (data) => {
    errorToast(data?.message);
  };
  const reFetch = () => {
    // if (!productId) return errorToast("Create general first");
    dispatch(
      productViewAction(page === "add" ? productId : id, onSuccess, onError)
    );
  };

  const onAddSuccess = (data) => {
    successToast(data?.message);
    reFetch();
  };
  const onAddError = (data) => {};

  const onDeleteSuccess = (data) => {
    successToast(data?.message);
    reFetch();
  };
  const onDeleteError = (data) => {};
  const [loading, setLoading] = useState(false);

  const onCompositionSuccess = (data) => {
    setCompositionList(
      data?.data?.list?.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };

  const onCompositionError = (data) => {
    errorToast(data);
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      compositionSearchListAction("", onCompositionSuccess, onCompositionError)
    );
  }, []);

  const handleAdd = (data, resetForm) => {
    //  molecule_name: values.molecule_name,
    //                       molecule_value: values.molecule_value,
    //                       molecule_unit: values.molecule_unit,
    console.log(productId, "888");
    if (productId === null || productId === undefined) {
      return errorToast("Fill general details first");
    } else if (data.molecule_name === "") return errorToast("name is required");
    else if (data.molecule_value === "")
      return errorToast("Weight Value is required");
    else if (data.molecule_unit === "")
      return errorToast("Weight Unit is required");

    dispatch(
      moleculeAddAction(
        data,
        (data) => {
          resetForm();
          successToast(data?.message);
          reFetch();
        },
        onAddError
      )
    );
  };
  const onClickDelete = (data) => {
    dispatch(
      moleculeDeleteAction(
        { molecule_composition_id: data },
        onDeleteSuccess,
        onDeleteError
      )
    );
  };
  const moleculeUnit = [
    { label: "Milligram (mg)", value: "Milligram (mg)" },
    { label: "Microgram (μg or mcg)", value: "Microgram (μg or mcg)" },
    { label: "Gram (g)", value: "Gram (g)" },
    { label: "International Unit (IU)", value: "International Unit (IU)" },
    { label: "Milliliter (mL)", value: "Milliliter (mL)" },
    { label: "Liter (L)", value: "Liter (L)" },
  ];

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={formValues?.planning ?? initialValues}
        // validationSchema={validationSchema}
        onSubmit={innerOnSubmit}
      >
        {({ values, handleSubmit, errors, resetForm }) => {
          return (
            <>
              <div className="flex flex-wrap mx-10">
                <div className="w-full flex flex-row gap-20">
                  <div className="flex-1">
                    <SelectField
                      containerClass="flex-1"
                      placeholder="Type molecule name"
                      options={compositionList}
                      label="Search Molecule"
                      id="molecule_name"
                      name="molecule_name"
                      isSearchable={true}
                      errMsgContainerClass="ps-2"
                      isRequired={true}
                      labelWidth="9rem"
                      isDisabled={disabled}
                    />
                  </div>
                  <div className="flex-1">
                    <InputField
                      isDisabled={disabled}
                      type="number"
                      name="molecule_value"
                      placeholder=""
                      label="Weight Value "
                      isRequired={true}
                      labelWidth="9rem"
                    />
                  </div>

                  <div className="flex-1">
                    {/* <InputField
                      isDisabled={disabled}
                      type="text"
                      name="molecule_unit"
                      placeholder="mg"
                      label="Weight Unit"
                      isRequired={true}
                      labelWidth="9rem"
                    /> */}
                    <SelectField
                      containerClass="flex-1"
                      placeholder="Select Unit"
                      options={moleculeUnit}
                      label="Weight Unit"
                      id="molecule_unit"
                      name="molecule_unit"
                      isSearchable={true}
                      errMsgContainerClass="ps-2"
                      isRequired={true}
                      labelWidth="9rem"
                      isDisabled={disabled}
                    />
                  </div>
                </div>
                <div className="w-full flex justify-end ">
                  <AddButton
                    onclkFn={() => {
                      if (!disabled) {
                        handleAdd(
                          {
                            item_id: productId,
                            molecule_name: values.molecule_name,
                            molecule_value: values.molecule_value,
                            molecule_unit: values.molecule_unit,
                          },
                          resetForm
                        );
                      }
                    }}
                    prefixIcon={true}
                    text="Add Molecule"
                    type="button"
                  />
                </div>
              </div>

              <div className="mt-5 mb-20">
                {console.log("itemGeneralData", itemGeneralData)}

                {dataList?.length > 0 && (
                  <div className="overflow-auto mx-10 mb-auto rounded-xl border border-gray-200">
                    <table className="w-full">
                      <thead className="sticky top-0 bg-[var(--create-table-header-bg)]">
                        <tr className="relative h-[50px]">
                          {tableHeading.map((heading, index) => (
                            <th
                              className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                              key={heading}
                            >
                              {heading}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {dataList.map((item, index) => (
                          <tr
                            className={` bg-[var(--list-table-row-bg)]
                         h-[50px] `}
                            key={index}
                          >
                            <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                              {item.molecule_name}
                              {/* <Field
                                name={`molecule_list[${index}].molecule_name`}
                                placeholder="Enter Code"
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                              /> */}
                            </td>
                            <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                              {item.molecule_value}
                              {item.molecule_unit}

                              {/* <Field
                                name={`molecule_list[${index}].molecule_value`}
                                placeholder="Enter Name"
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                              /> */}
                            </td>

                            <td className="tab-cell align-middle text-sm fw_400 text-secondary w-1/12 ">
                              <div className="flex items-center">
                                <button
                                  type="button"
                                  onClick={() => {
                                    if (!disabled) {
                                      onClickDelete(
                                        item?.molecule_composition_id
                                      );
                                    }
                                  }}
                                >
                                  <DeleteIcon />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              {!disabled && (
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    onclkFn={handleSubmit}
                    prefixIcon={false}
                    text="Save"
                    type="button"
                  />
                </div>
              )}
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default MoleculeTab;

const tableHeading = ["Molecule Name", "Molecule Weight", "Action"];
